module.exports = __webpack_public_path__ + "img/playVideo.afda57da.png";